import { Setting } from "../App";
import { FC, useCallback, useEffect, useRef } from "react";
import { useSubscriptionAdd } from "../hooks/use-subscription-add";
import { AddSubscriptionLineResponseTypeDefine } from "../types/api/add-subscription-line-api-type";

export const SubscriptionAdd: FC<{ setting: Setting }> = ({ setting }) => {
  const { parameters, setParameters, subscriptionAdd } =
    useSubscriptionAdd(setting);
  const loading = useRef(false);

  useEffect(() => {
    window.parent.postMessage({ action: "prepared" }, "*");
  }, []);

  useEffect(() => {
    window.addEventListener("message", async function (e) {
      if (e.data.product) {
        setParameters({
          variantId: e.data.product.variantId,
          quantity: e.data.product.quantity,
          sellingPlanId: e.data.product.sellingPlanId,
          price: e.data.product.price,
          planPrice: e.data.product.planPrice,
          btnTitle: e.data.product.btnTitle,
          btnClassName: e.data.product.btnClassName,
        });
      }
    });
  }, [setParameters]);

  useEffect(() => {
    window.addEventListener("message", async function (e) {
      if (!e.data.okAddSubscription) return;

      if (loading.current) return;
      loading.current = true;

      const response = await subscriptionAdd();

      loading.current = false;

      if (
        response === AddSubscriptionLineResponseTypeDefine.PARAMETERS_UNDEFINED
      )
        return;

      window.parent.postMessage(
        {
          action: "apiResult",
          type: response,
        },
        "*"
      );
    });
  }, [subscriptionAdd]);

  const btnClick = useCallback(() => {
    window.parent.postMessage({ action: "btnClicked" }, "*");
  }, []);

  let btnPrice = <></>;

  if (parameters) {
    btnPrice = (
      <>
        <div>{parameters.price}</div>
      </>
    );

    if (parameters.price !== parameters.planPrice) {
      btnPrice = (
        <>
          <div>
            <span style={{ textDecoration: "line-through" }}>
              {parameters.price}
            </span>
            &nbsp;&#8594;&nbsp;
            {parameters.planPrice}
          </div>
        </>
      );
    }
  }

  return (
    <>
      <button
        onClick={btnClick}
        disabled={loading.current}
        className={parameters ? parameters.btnClassName : ""}
      >
        <div
          dangerouslySetInnerHTML={{
            __html: parameters ? parameters.btnTitle : "",
          }}
        />
        {btnPrice}
      </button>
    </>
  );
};
